import React, {Component} from "react";
import PropTypes from 'prop-types';
import {units} from "../../modal/units";

import "./units.css";

class Unit extends Component {

  render() {

    let {unitId} = this.props.match.params;
    let {post} = units[unitId];
    return (
      <div
        style={{
        flexGrow: 1,
        position: "relative",
        display: "flex"
      }}>
        {postFormatter[post.type](post) || null}
      </div>
    );
  }
}

Unit.propTypes = {
  match: PropTypes.object.isRequired
};

const pdfViewer = (el) => {
  var viewerOrigin = new URL(window.location.href).origin || 'null';
  let resLocation = null;
  if (viewerOrigin) {
    resLocation = viewerOrigin + "/pdfjs/web/_AVCUR.html";
  }
  return (<iframe
    title="pdf-frame"
    src={resLocation + "?file=" + el.link + "#zoom=page-height"}
    style={{
    flexGrow: 1
  }}/>);
}

const pptViewer = (el) => {
  if (!el.link) {
    return null;
  } else {
    return (<iframe
      title="ppt-frame"
      src={el.link}
      frameBorder="0"
      width="100%"
      height="100%"
      allowFullScreen="true"/>)
  }
}

const videoViewer = (el) => {
  if (!el.link) {
    return null;
  } else {
    return <iframe
      title="video-frame"
      width="100%"
      height="100%"
      src={el.link}
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullscreen>
    </iframe>
  }
}

const postFormatter = {
  "pdf": pdfViewer,
  "ppt": pptViewer,
  "video": videoViewer
}

export default Unit;


// WEBPACK FOOTER //
// ./src/containers/application/Unit.js